import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Logo } from "@/components/Logo";

export function Nav() {
  const { content } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => setOpen(false), [pathname]);

  const solid = scrolled || open;
  const nav = content.nav;
  return (
    <header data-testid="site-header" className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${solid ? "bg-white/95 backdrop-blur-xl border-b border-[var(--line)] text-black" : "bg-transparent border-b border-transparent text-white"}`}>
      <div className="container-x flex h-[68px] items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" className="relative z-10 shrink-0"><Logo className="h-10" testId="header-official-logo" light={!solid} /></Link>
        <nav className="hidden lg:flex items-center gap-8" aria-label={content.ui.mainNavigation}>
          {nav.map((n) => (
            <NavLink key={n.path} to={n.path} data-testid={`nav-link-${n.path.replace("/", "")}`}
              className={({ isActive }) => `relative text-[13.5px] font-medium transition-opacity duration-300 ${isActive ? "opacity-100" : "opacity-60 hover:opacity-100"}`}>
              {({ isActive }) => (<>{n.label}{isActive && <motion.span layoutId="nav-underline" className="absolute -bottom-2 left-0 h-px w-full bg-current" />}</>)}
            </NavLink>
          ))}
          <Link to="/contact" data-testid="nav-contact-cta" className={`ml-2 inline-flex items-center gap-2 border px-4 py-2 text-[13px] font-medium transition-colors ${solid ? "border-black/30 hover:bg-black hover:text-white" : "border-white/40 hover:bg-white hover:text-black"}`}>
            {content.ui.contactUs} <ArrowUpRight size={14} />
          </Link>
        </nav>
        <button data-testid="nav-mobile-toggle" className="lg:hidden p-2" onClick={() => setOpen((v) => !v)} aria-label="Menu">{open ? <X size={22} /> : <Menu size={22} />}</button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div data-testid="nav-mobile-menu" initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -8 }} className="lg:hidden border-t border-[var(--line)] bg-white">
            <div className="container-x flex flex-col py-6">
              {nav.map((n) => (
                <NavLink key={n.path} to={n.path} data-testid={`nav-mobile-link-${n.path.replace("/", "")}`} className="font-head text-2xl py-3 border-b border-[var(--line)] text-black">{n.label}</NavLink>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
